// Publishes the git sha of the build on `window`.
//
// Nothing may import this module. Read window.__peatixBuildSha instead, as
// plugins/rum.ts does.
//
// This is a build entry of its own — emitted, and given a <script> in
// index.html, by the buildVersionEntry plugin in vite.config.ts — rather than a
// module the app imports. Rollup writes the hashed file name of an imported
// chunk into the importing chunk, so importing this would propagate a new hash
// up through the app bundle on every build, which is the opposite of what
// splitting it out is for. index.html is rendered server side
// (root/peaz-us.tx) and never cached, so the reference to the hashed file lives
// there and only this chunk is refetched after a deploy.
//
// The value comes from `__PEATIX_BUILD_SHA__`, defined in vite.config.ts.

declare const __PEATIX_BUILD_SHA__: string;

declare global {
	interface Window {
		__peatixBuildSha?: string;
	}
}

window.__peatixBuildSha = __PEATIX_BUILD_SHA__;

export {};
